import { IconButtonToneContext } from '../contexts'
import { EmptyState } from './EmptyState'

const renderEmptyState = empty => {
  if (typeof empty === 'string') {
    return <EmptyState title={empty} />
  }

  return empty || <EmptyState title="Nothing Here Yet" />
}

export const DataTable = ({
  actions,
  columns = [],
  empty,
  footer,
  getRowKey = row => row.id,
  rows = [],
}) => (
  <div>
    <table className="ds-data-table" role="table">
      <thead role="rowgroup">
        <tr role="row">
          {columns.map(column => (
            <th className={column.className} key={column.key} role="columnheader" scope="col" style={column.width ? { width: column.width } : undefined}>{column.label}</th>
          ))}
          {actions && <th aria-label="Actions" className="tw:w-24" role="columnheader" scope="col" />}
        </tr>
      </thead>
      <tbody role="rowgroup">
        {rows.map(row => (
          <tr key={getRowKey(row)} role="row">
            {columns.map(column => (
              <td
                className={column.cellClassName}
                data-label={column.label}
                data-primary={column.primary ? 'true' : undefined}
                data-span={column.span ? 'true' : undefined}
                key={column.key}
                role="cell"
              >
                {column.render ? column.render(row) : row[column.key]}
              </td>
            ))}
            {actions && (
              <td data-label="Actions" data-span="true" role="cell">
                <IconButtonToneContext.Provider value="table">
                  <div className="ds-row-actions" onClick={event => event.stopPropagation()}>{actions(row)}</div>
                </IconButtonToneContext.Provider>
              </td>
            )}
          </tr>
        ))}
        {rows.length === 0 && (
          <tr className="ds-table-static" role="row">
            <td colSpan={columns.length + (actions ? 1 : 0)} data-span="true" role="cell">
              <div aria-live="polite" role="status">{renderEmptyState(empty)}</div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
    {footer && <div className="ds-helper tw:border-t tw:border-default tw:px-0 tw:py-3">{footer}</div>}
  </div>
)
